import type { HubSection } from '@/components/Hub/hubSectionTypes';
import { spotlightSection } from '@/components/Hub/sections/spotlightSection';
import { storiesSection } from '@/components/Hub/sections/storiesSection';
import { simulationsSection } from '@/components/Hub/sections/simulationsSection';
import { lessonsSection } from '@/components/Hub/sections/lessonsSection';
import { challengesSection } from '@/components/Hub/sections/challengesSection';
import { librarySection } from '@/components/Hub/sections/librarySection';

// Never filter or reorder this at runtime. Each section owns a hook so the order has to hold.
export const HUB_SECTIONS: readonly HubSection[] = [
    spotlightSection,
    storiesSection,
    simulationsSection,
    lessonsSection,
    challengesSection,
    librarySection,
];
